/* eslint-disable max-len */
/* eslint no-confusing-arrow: ["error", {allowParens: true}] */

import styled, { css } from 'styled-components';

import appLogger from 'app/shared/loggers/appLogger';

// vars
const THEME_VALIDATION = 'props => props.theme && props.theme.ns';

const STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    DECLINED: 'declined',
};

const bgAlpha = 0.65;

const hexToRgb = (hex) => {
    // https://github.com/styled-components/polished/issues/104
    // http://stackoverflow.com/a/5624139
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
    } : null;
};

const rgba = (hex, alpha) => {
    const color = hexToRgb(hex);
    return `rgba(${color.r}, ${color.g}, ${color.b}, ${alpha})`;
};

const handleType = (code, colors) => {
    switch (code) {
        case STATUS.ACTIVE:
            return colors.purple600;
        case STATUS.INACTIVE:
            return rgba(colors.black, bgAlpha);
        case STATUS.DECLINED:
            return colors.red400;
        default:
            appLogger.logInfo({
                message: `No case for: ${code}`,
                context: 'PropertyStatus.handleType',
            });
            return colors.black;
    }
};

export const StyledPropertyStatus = styled.div`
    display: inline-block;
    padding: 4px 16px;
    color: #fff;
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;

    ${props => THEME_VALIDATION && css`
        background-color: ${handleType(props.code, props.theme.ns().colors)}
    `};
`;
